module.exports = __webpack_public_path__ + "img/steam-turbine-V.3e615273.png";